/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
	/** set parameter to `true` for call `securityWorker` for this request */
	secure?: boolean;
	/** request path */
	path: string;
	/** content type of request body */
	type?: ContentType;
	/** query params */
	query?: QueryParamsType;
	/** format of response (i.e. response.json() -> format: "json") */
	format?: ResponseFormat;
	/** request body */
	body?: unknown;
	/** base url */
	baseUrl?: string;
	/** request cancellation token */
	cancelToken?: CancelToken;
}

export type RequestParams = Omit<
	FullRequestParams,
	"body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
	baseUrl?: string;
	baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
	securityWorker?: (
		securityData: SecurityDataType | null,
	) => Promise<RequestParams | void> | RequestParams | void;
	customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
	extends Response {
	data: D;
	error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
	Json = "application/json",
	JsonApi = "application/vnd.api+json",
	FormData = "multipart/form-data",
	UrlEncoded = "application/x-www-form-urlencoded",
	Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
	public baseUrl: string = "https://api.v3.dxfamt.dev.agco-opsmgmt.com";
	private securityData: SecurityDataType | null = null;
	private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
	private abortControllers = new Map<CancelToken, AbortController>();
	private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
		fetch(...fetchParams);

	private baseApiParams: RequestParams = {
		credentials: "same-origin",
		headers: {},
		redirect: "follow",
		referrerPolicy: "no-referrer",
	};

	constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
		Object.assign(this, apiConfig);
	}

	public setSecurityData = (data: SecurityDataType | null) => {
		this.securityData = data;
	};

	protected encodeQueryParam(key: string, value: any) {
		const encodedKey = encodeURIComponent(key);
		return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
	}

	protected addQueryParam(query: QueryParamsType, key: string) {
		return this.encodeQueryParam(key, query[key]);
	}

	protected addArrayQueryParam(query: QueryParamsType, key: string) {
		const value = query[key];
		return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
	}

	protected toQueryString(rawQuery?: QueryParamsType): string {
		const query = rawQuery || {};
		const keys = Object.keys(query).filter(
			key => "undefined" !== typeof query[key],
		);
		return keys
			.map(key =>
				Array.isArray(query[key])
					? this.addArrayQueryParam(query, key)
					: this.addQueryParam(query, key),
			)
			.join("&");
	}

	protected addQueryParams(rawQuery?: QueryParamsType): string {
		const queryString = this.toQueryString(rawQuery);
		return queryString ? `?${queryString}` : "";
	}

	private contentFormatters: Record<ContentType, (input: any) => any> = {
		[ContentType.Json]: (input: any) =>
			input !== null &&
			(typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.JsonApi]: (input: any) =>
			input !== null &&
			(typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.Text]: (input: any) =>
			input !== null && typeof input !== "string"
				? JSON.stringify(input)
				: input,
		[ContentType.FormData]: (input: any) => {
			if (input instanceof FormData) {
				return input;
			}

			return Object.keys(input || {}).reduce((formData, key) => {
				const property = input[key];
				formData.append(
					key,
					property instanceof Blob
						? property
						: typeof property === "object" && property !== null
							? JSON.stringify(property)
							: `${property}`,
				);
				return formData;
			}, new FormData());
		},
		[ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
	};

	protected mergeRequestParams(
		params1: RequestParams,
		params2?: RequestParams,
	): RequestParams {
		return {
			...this.baseApiParams,
			...params1,
			...(params2 || {}),
			headers: {
				...(this.baseApiParams.headers || {}),
				...(params1.headers || {}),
				...((params2 && params2.headers) || {}),
			},
		};
	}

	protected createAbortSignal = (
		cancelToken: CancelToken,
	): AbortSignal | undefined => {
		if (this.abortControllers.has(cancelToken)) {
			const abortController = this.abortControllers.get(cancelToken);
			if (abortController) {
				return abortController.signal;
			}
			return void 0;
		}

		const abortController = new AbortController();
		this.abortControllers.set(cancelToken, abortController);
		return abortController.signal;
	};

	public abortRequest = (cancelToken: CancelToken) => {
		const abortController = this.abortControllers.get(cancelToken);

		if (abortController) {
			abortController.abort();
			this.abortControllers.delete(cancelToken);
		}
	};

	public request = async <T = any, E = any>({
		body,
		secure,
		path,
		type,
		query,
		format,
		baseUrl,
		cancelToken,
		...params
	}: FullRequestParams): Promise<HttpResponse<T, E>> => {
		const secureParams =
			((typeof secure === "boolean"
				? secure
				: this.baseApiParams.secure) &&
				this.securityWorker &&
				(await this.securityWorker(this.securityData))) ||
			{};
		const requestParams = this.mergeRequestParams(params, secureParams);
		const queryString = query && this.toQueryString(query);
		const payloadFormatter =
			this.contentFormatters[type || ContentType.Json];
		const responseFormat = format || requestParams.format;

		return this.customFetch(
			`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
			{
				...requestParams,
				headers: {
					...(requestParams.headers || {}),
					...(type && type !== ContentType.FormData
						? { "Content-Type": type }
						: {}),
				},
				signal:
					(cancelToken
						? this.createAbortSignal(cancelToken)
						: requestParams.signal) || null,
				body:
					typeof body === "undefined" || body === null
						? null
						: payloadFormatter(body),
			},
		).then(async response => {
			const r = response as HttpResponse<T, E>;
			r.data = null as unknown as T;
			r.error = null as unknown as E;

			const data = !responseFormat
				? r
				: await response[responseFormat]()
						.then(data => {
							if (r.ok) {
								r.data = data;
							} else {
								r.error = data;
							}
							return r;
						})
						.catch(e => {
							r.error = e;
							return r;
						});

			if (cancelToken) {
				this.abortControllers.delete(cancelToken);
			}

			if (!response.ok) throw data;
			return data;
		});
	};
}

/**
 * @title Data Exchange for Agricultural Machine Terminals
 * @version 3
 * @baseUrl https://api.v3.dxfamt.dev.agco-opsmgmt.com
 * @contact <agco-opsmgmt@agcocorp.com>
 *
 * This service provides a number of APIs for converting terminal data between various formats. It primarily focuses on the field geometry and guidance patterns
 */
export class Api<
	SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
	proxy = {
		/**
		 * No description
		 *
		 * @tags Conversion
		 * @name OptionsProxy
		 * @request OPTIONS:/{proxy+}
		 */
		optionsProxy: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/{proxy+}`,
				method: "OPTIONS",
				format: "json",
				...params,
			}),
	};
	jobs = {
		/**
		 * @description Method to create a job for a conversion. The job must specify the `target_format` and `action` but all other can be left out. The default for `source_format` is `auto` which means it automatically detect the import format. The two `auto_` options are used to limit the formats `auto` is allowed to use. The job will return an is to be used to identify statuses send over websocket and two presigned urls time limited to 60 min. - upload. This is to be used to PUT the file with ContentType': 'application/zip - download. If the conversion completes the output can be GET using this
		 *
		 * @tags Conversion
		 * @name JobsCreate
		 * @summary Create a new conversion job
		 * @request POST:/jobs
		 * @secure
		 */
		jobsCreate: (
			data: {
				/**
				 * The action to perform
				 * @default "convert"
				 * @example "convert"
				 */
				action: string;
				/**
				 * The input format if known, use the supported input formats to obtain valid values
				 * @default "Auto"
				 * @example "Auto"
				 */
				source_format?: string;
				/**
				 * The desired output format. Use the supported target formats to obtain a list of supported formats
				 * @example "ISOXML4"
				 */
				target_format: string;
				/** Exclude an importer from the import intended to be used for the Auto import-format. */
				auto_source_exclude_formats?: string[];
				/** If specified only the importers where the pattern matches one of their id is considered. This is to control the Auto import that other wise considers all available importers */
				auto_source_include_formats?: string[];
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					/**
					 * Url to be used for uploading the input file
					 * @format uri
					 * @example "https://example.com/upload"
					 */
					upload_url?: string;
					/**
					 * Url that becomes avaliable when the job is done
					 * @format uri
					 * @example "https://example.com/download"
					 */
					download_url?: string;
					/**
					 * The job id. Check for this in the web socket if thats used for status
					 * @format uuid
					 * @example "a0351ad7-07a2-4c48-a1f9-a664b6b49c11"
					 */
					job_id?: string;
					/**
					 * The time at which the job is removd and the download link is permanently blocked
					 * @format date-time
					 * @example "2025-07-10T12:22:25.134739+00:00"
					 */
					expires?: string;
				},
				any
			>({
				path: `/jobs`,
				method: "POST",
				body: data,
				secure: true,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	ws = {
		/**
		 * @description This endpoint is a websocket with outgoing messages (NOT a http get). The `api.` prefix must be set to `ws.` and the path part of the url left empty Outgoing messages: - `StatusMessage`
		 *
		 * @tags Conversion
		 * @name GetWs
		 * @summary WebSocket endpoint for job status
		 * @request GET:/ws
		 * @secure
		 */
		getWs: (
			query: {
				/** The authentication token required to connect to the WebSocket. */
				token: string;
			},
			params: RequestParams = {},
		) =>
			this.request<
				{
					job?: string;
					/** The current state of the job */
					status?:
						| "created"
						| "processing"
						| "failed"
						| "error"
						| "completed";
					/** Optional description of the current status */
					messages?: string;
				},
				any
			>({
				path: `/ws`,
				method: "GET",
				query: query,
				secure: true,
				format: "json",
				...params,
			}),
	};
	convert = {
		/**
		 * @description Returns a list of supported input formats
		 *
		 * @tags Conversion
		 * @name InputFormatsList
		 * @summary Get the supported input formats
		 * @request GET:/convert/input-formats
		 * @secure
		 */
		inputFormatsList: (params: RequestParams = {}) =>
			this.request<object[], any>({
				path: `/convert/input-formats`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Returns a list of supported target formats
		 *
		 * @tags Conversion
		 * @name TargetFormatsList
		 * @summary Get the supported target formats
		 * @request GET:/convert/target-formats
		 * @secure
		 */
		targetFormatsList: (params: RequestParams = {}) =>
			this.request<object[], any>({
				path: `/convert/target-formats`,
				method: "GET",
				secure: true,
				format: "json",
				...params,
			}),

		/**
		 * @description Generated usage data of the APIs
		 *
		 * @tags DevOps
		 * @name TelemetryList
		 * @summary Get telemetry data
		 * @request GET:/convert/telemetry
		 * @secure
		 */
		telemetryList: (params: RequestParams = {}) =>
			this.request<string, any>({
				path: `/convert/telemetry`,
				method: "GET",
				secure: true,
				...params,
			}),
	};
	health = {
		/**
		 * No description
		 *
		 * @tags DevOps
		 * @name HealthList
		 * @request GET:/health
		 */
		healthList: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/health`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
}
